import JoyTabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab from '@mui/joy/Tab';
import { SyntheticEvent } from 'react';
import { useTheme } from '@mui/joy';
import { SimpleOption } from '../../types';

export interface TabProps {
	value: number | string | null;
	onChange?: (value: number | string | null) => void;
	options: SimpleOption[];
	width: string;
	print?: boolean;
}

export default function Tabs({
	value = 0,
	options = [],
	onChange = (value) => console.log(value),
	width = '',
	print
}: TabProps) {
	const theme = useTheme();
	//const [index, setIndex] = useState<string | number | null>(value);
	//console.log('value', value);
	const TAB_SX = {
		width: width,
		border: `1px solid ${theme.colorSchemes.light.palette.controls.controlFill}`,
		//outline: `1px solid ${theme.colorSchemes.light.palette.controls.controlFill}`,
		padding: '0px',
		[`&::after`]: {
			background: 'none'
		},
		[`&.Mui-selected`]: {
			backgroundColor: theme.colorSchemes.light.palette.controls.controlFill,
			color: 'white',
			fontWeight: 900
		}
	};

	const handleChange = (
		_event: SyntheticEvent<Element, Event> | null,
		value: string | number | null
	) => {
		//setIndex(value as number);
		onChange(value);
	};
	return (
		<JoyTabs
			aria-label='tabs'
			value={value}
			onChange={handleChange}
			sx={{
				width: 'max-content',
				padding: 0,
				marginBottom: print ? '1rem' : 0
			}}
		>
			<TabList
				variant='soft'
				sx={{
					boxShadow: 'none',
					fontFamily: 'Source Sans Pro, sans-serif',
					fontSize: '16px'
				}}
			>
				<Tab
					aria-label={options[0].label}
					sx={{
						...TAB_SX,
						borderRadius: '8px 0 0 8px',
						lineHeight: 0,
						paddingBottom: print ? '1.25rem' : 0
					}}
				>
					{options[0].label}
				</Tab>
				<Tab
					aria-label={options[1].label}
					sx={{
						...TAB_SX,
						borderRadius: '0 8px 8px 0',
						lineHeight: 0,
						paddingBottom: print ? '1.25rem' : 0
					}}
				>
					{options[1].label}
				</Tab>
			</TabList>
		</JoyTabs>
	);
}
